import { Ng2StateDeclaration } from '@uirouter/angular';
import browserHelper from '@utils/browser-helper';

export const authState: Ng2StateDeclaration[] = [
  {
    name: 'email-change-confirmation',
    url: '/email-change-confirmation?u&t',
    loadComponent: () =>
      import('./containers/email-change-confirmation/email-change-confirmation.component').then(
        m => m.EmailChangeConfirmationComponent
      ),
    data: {
      bodyClass: ['app-footer', 'app-white']
    }
  },
  {
    name: 'find-company',
    url: '/find-company',
    loadComponent: () => import('./containers/find-company/find-company.component').then(m => m.FindCompanyComponent),
    data: {
      bodyClass: ['app-footer', 'app-white']
    }
  },
  {
    name: 'find-company-email-sent',
    url: '/find-company/email-sent',
    params: {
      email: ''
    },
    loadComponent: () =>
      import('./containers/find-company/email-sent/find-company-email-sent.component').then(
        m => m.FindCompanyEmailSentComponent
      ),
    data: {
      bodyClass: ['app-footer', 'app-white']
    }
  },
  {
    name: 'register-blocked',
    url: '/register/blocked',
    loadComponent: () =>
      import('./containers/register/blocked/register-blocked.component').then(m => m.RegisterBlockedComponent),
    data: {
      bodyClass: ['app-white']
    }
  },
  {
    name: 'register',
    url: '/register',
    loadComponent: () => import('./containers/register/register.component').then(m => m.RegisterComponent),
    data: {
      bodyClass: ['app-white'],
      showHeader: false,
      ignoreStateAsTitle: true
    }
  },
  {
    name: 'register-email-sent',
    url: '/register/email-sent',
    params: {
      email: ''
    },
    loadComponent: () =>
      import('./containers/register/email-sent/register-email-sent.component').then(m => m.RegisterEmailSentComponent),
    data: {
      bodyClass: () => (browserHelper.isMobile ? 'app-white' : ['app-white'])
    }
  }
];
